import { isPylonAccessAllowed } from "./pylon-access";

export const openSupportChat = () => {
  if (isPylonAccessAllowed() && window.Pylon) {
    window.Pylon("show");
  }
};

export const openSupportChatWithMessage = (message: string) => {
  if (!isPylonAccessAllowed() || !window.Pylon) return false;
  window.Pylon("showNewMessage", message);
  return true;
};
